import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { setActiveBacteria, setHoverPos } from '../actions';
import ThreeDModel from '../components/3d-model';

class BacteriaChoice extends Component {

    constructor(props) {
        super(props);
        this.ref = React.createRef();

        this.state = {
            showModel: false
        };

        this._goToBacteria = this._goToBacteria.bind(this);
        this._logPosition = this._logPosition.bind(this);
    }

    componentDidMount() {
        const { choiceStatus, bacteria } = this.props;

        if( choiceStatus && bacteria.id === "sphere" ) {
            this.setState({
                showModel: true
            });
        }
    }

    componentDidUpdate() {
        const { bacteria, choiceStatus } = this.props;
        const { showModel } = this.state;

        if( choiceStatus && bacteria.id === "sphere" && !showModel ) {
            this.setState({
                showModel: true
            });
        }

    }

    _goToBacteria() {
        const { goToBacteria, bacteria } = this.props;
        goToBacteria( bacteria );
    }

    _logPosition() {
        const { setHoverPos } = this.props;
        const coords = this.ref.current.getBoundingClientRect();
        const width = this.ref.current.offsetWidth;
        const height = this.ref.current.offsetHeight;
        setHoverPos( Math.ceil( coords.x + width/2 ), Math.ceil( coords.y + height/2 ) );
    }

    render() {
        const { bacteria } = this.props;
        const { showModel } = this.state;

        return (
            <div className="bacteria-choice" onMouseEnter={this._logPosition} ref={this.ref}
                 onClick={this._goToBacteria}>
                { ( bacteria.placeholder !== undefined ) ? (
                    <div className={ "bacteria-choice-placeholder " +  bacteria.id }>
                        <img src={ bacteria.placeholder } alt={ bacteria.name } />
                    </div>
                    ):(
                    <ThreeDModel bacteria={bacteria}/>
                    ) }

            </div>
        );
    }

}

const mapStateTopProps = ( state ) => {
    return {
        choiceStatus: state.chooseABacteriaStatus
    }
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        goToBacteria: ( bacteria ) => {
            dispatch(setActiveBacteria(bacteria));
            dispatch(push( process.env.PUBLIC_URL + '/bacteria/'+bacteria.id) );
        },
        setHoverPos: ( xPos, yPos ) => {
            dispatch( setHoverPos( xPos, yPos ) );
        }
    }
}

export default connect(mapStateTopProps,mapDispatchToProps)(BacteriaChoice);



// WEBPACK FOOTER //
// ./src/components/bacteria-choice.js